import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { Provider } from '@angular/core'
import { EbCmsTicketInterceptor } from './eb-cms-ticket.interceptor'

export const interceptors: Provider[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useExisting: EbCmsTicketInterceptor,
    multi: true
  }
]
